import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.status.forbidden');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-status-forbidden',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.status.forbidden/view.scss */
:host {
  display: block;
  min-height: 100%;
}`],
})
export class PageStatusForbiddenComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public goWorkspace() {
        this.service.href('/workspace');
    }

    public goAccess() {
        this.service.href('/access');
    }
}

export default PageStatusForbiddenComponent;